import { Directive, ElementRef, HostListener, inject } from '@angular/core';

/**
 * Enlace que, si ya estás en su destino, recarga la página: el router ignora la
 * navegación a la misma URL y el clic parecía no hacer nada.
 */
@Directive({ selector: 'a[reloadIfCurrent]' })
export class ReloadIfCurrentDirective {
  private el = inject<ElementRef<HTMLAnchorElement>>(ElementRef).nativeElement;

  @HostListener('click', ['$event'])
  onClick(e: MouseEvent): void {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0) return; // nueva pestaña: no tocar
    if (new URL(this.el.href).pathname === location.pathname) location.reload();
  }
}
